// extracted by mini-css-extract-plugin
export default {"skipToMainContent":"Custom_skipToMainContent__pgUvq"};